import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import fr from 'facet-rest';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import WizardStepWrapperTemplate from 'Views/Page/Content/Templates/WizardTemplates/WizardStepWrapperTemplate';
import Content from './Content';
import metaOverrideSet from './MetaOverrideSet/metaOverrideSet';

const styles = () => ({
  root: {},
});

const AccountOpeningAgreementV2Template = ({
  className,
  classes,
  resource,
  handleNext,
}) => {
  const hasErrors = resource.attr('errors')?.resources()?.list().length > 0;

  return (
    <WizardStepWrapperTemplate
      className={classNames(className, classes.root)}
      metaOverrideSet={metaOverrideSet}
      resource={resource}
      layout={Content}
      onNext={handleNext}
      LayoutProps={{
        ErrorListProps: {
          scrollIntoView: true,
        },
        onlyRenderLayout: true,
      }}
      disableNextButton={hasErrors}
    />
  );
};

AccountOpeningAgreementV2Template.defaultProps = {
  className: '',
};

AccountOpeningAgreementV2Template.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
  handleNext: PropTypes.func.isRequired,
};

export default withStyles(styles)(AccountOpeningAgreementV2Template);
